import Badge from '@mui/material/Badge'
import Button from '@mui/material/Button'
import FilterListIcon from '@mui/icons-material/FilterList'
import { gridFilterModelSelector, useGridApiContext } from '@mui/x-data-grid-pro'

declare module '@mui/x-data-grid-pro' {
  interface GridLocaleText {
    resetFiltersButton: string
  }
}

export function DataGridToolbarResetFilteringButton() {
  const gridApiRef = useGridApiContext()

  const filterModel = gridFilterModelSelector(gridApiRef)

  const handleClick = () => {
    gridApiRef.current.setFilterModel({ ...filterModel, items: [] })
  }

  return (
    <Button
      onClick={handleClick}
      size='small'
      startIcon={
        <Badge badgeContent={filterModel.items.length} color='primary'>
          <FilterListIcon fontSize='inherit' />
        </Badge>
      }
      variant='text'
    >
      {gridApiRef.current.getLocaleText('resetFiltersButton')}
    </Button>
  )
}
